import React from 'react';
import { userUpdate } from '@ts/utils/iterableUtils';
import { AnalyticsInstance } from '@ts/utils/analytics';
import { get } from '@ts/utils/cs';
import { get as getFromLS, set as setInLS } from '@ts/utils/ls';

export const GoogleAuth = () => {
    React.useEffect(() => {
        const script = document.createElement('script');
        script.setAttribute('async', true);
        script.setAttribute('defer', true);
        script.setAttribute('id', 'googleOneTap');
        script.setAttribute('src', 'https://accounts.google.com/gsi/client');
        const parseJwt = (token) => {
            const base64Url = token.split('.')[1];
            const base64 = decodeURIComponent(
                atob(base64Url)
                    .split('')
                    .map((c) => {
                        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                    })
                    .join('')
            );

            return JSON.parse(base64);
        };
        window.handleCredentialResponse = (response) => {
            const data = parseJwt(response.credential);
            const payload = {
                email: data.email,
                firstName: data.given_name ? data.given_name : '',
                lastName: data.family_name ? data.family_name : '',
                fullName: data.name ? data.name : '',
                picture: data.picture,
            };
            userUpdate(data.email, payload);
            AnalyticsInstance.account.contactInfo(payload);
            AnalyticsInstance.OneTapEvent(response.select_by);
            document.cookie = 'user=' + JSON.stringify(payload);
            const contactInfoInLS = getFromLS('_ts__contact-info');
            if (!contactInfoInLS) {
                setInLS('_ts__contact-info', {
                    user_id: null,
                    user_info: {
                        email: data.email,
                        first_name: data.given_name,
                        last_name: data.family_name,
                        phone: '',
                        phone2: '',
                    },
                });
            } else {
                setInLS('_ts__contact-info', {
                    user_id: contactInfoInLS.user_id,
                    user_info: {
                        email: data.email,
                        first_name: data.given_name ? data.given_name : contactInfoInLS.first_name,
                        last_name: data.family_name ? data.family_name : contactInfoInLS.last_name,
                        phone: contactInfoInLS.phone,
                        phone2: contactInfoInLS.phone2,
                    },
                });
            }
        };
        document.head.appendChild(script);
    }, []);
    const isAuth = get('user');
    return (
        <>
            {!isAuth && (
                <div
                    id="g_id_onload"
                    data-client_id="706715915018-4novupelq0lre87o6atkotsm9iau7qb5.apps.googleusercontent.com"
                    data-auto_select="true"
                    data-callback="handleCredentialResponse"
                />
            )}
        </>
    );
};
